"use strict";import{LitElement as e}from"lit";export class CiscoUElement extends e{}
//# sourceMappingURL=Base.js.map
